import ls from "local-storage";
const appName = "@FrontendCyclope";

async function save(request: string, dataSource: any) {
    const cacheAvailable = 'caches' in window;
    if (cacheAvailable) {
        const cache = await window.caches.open(appName);
        cache.put(request, new Response(JSON.stringify(dataSource)))
    } else {
        ls.set(`${appName}${request}`, dataSource);
    }
}

async function retrieve(request: string) {
    const cacheAvailable = 'caches' in window;
    if (cacheAvailable) {
        const cache = await window.caches.open(appName),
        response = await cache.match(request);

        if (response && response.status === 200) {
            const json = await response.json();
            return json;
        }
    } else {
        const value = ls(`${appName}${request}`);
        if (value !== null) {
            return JSON.parse(value);
        }
    }
    return undefined;
}

async function destroy(request: string) {
    const cacheAvailable = 'caches' in window;
    if (cacheAvailable) {
        const cache = await window.caches.open(appName);
        cache.delete(request);
    } else {
        ls.remove(`${appName}${request}`);
    }
    return true;
}

const DB = {
    save,
    retrieve,
    destroy
}
export default DB;
